import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Tooltip from 'core/elements/tooltip'
import Theme from 'core/themes/model'
import { StoreState, StoreStatus } from './imageStores'

// Each store state maps to a dot colour (matching the host "Role Status" column) and a tooltip.
// Colour carries the meaning: green = stored, yellow = still copying, red = copy failed.
const STATE_META: Record<StoreState, { colorClass: 'green' | 'yellow' | 'red'; tooltip: string }> =
  {
    stored: { colorClass: 'green', tooltip: 'Stored in this store' },
    importing: { colorClass: 'yellow', tooltip: 'Importing to this store…' },
    failed: { colorClass: 'red', tooltip: 'Import to this store failed' },
  }

const useStyles = makeStyles((theme: Theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  dot: {
    fontSize: 12,
    marginRight: theme.spacing(1),
  },
  green: { color: theme.palette.green.main },
  yellow: { color: theme.palette.yellow.main },
  red: { color: theme.palette.red.main },
}))

// Renders the Stores column cell for one image: a coloured dot per store (green stored, yellow
// importing, red failed) with the store name, stacked one per line. Empty -> em dash.
export default function ImageStoresCell({ storeStatuses }: { storeStatuses: StoreStatus[] }) {
  const classes = useStyles()
  if (!storeStatuses?.length) {
    return <span>—</span>
  }
  return (
    <div>
      {storeStatuses.map(({ id, state }) => {
        const meta = STATE_META[state]
        return (
          <Text variant="body2" className={classes.row} key={id}>
            <Tooltip message={meta.tooltip}>
              <FontAwesomeIcon className={clsx(classes.dot, classes[meta.colorClass])} solid>
                circle
              </FontAwesomeIcon>
            </Tooltip>
            <span data-testid={`image-store-${state}-${id}`}>{id}</span>
          </Text>
        )
      })}
    </div>
  )
}
